export const fileToBlob = async (file: File) => new Blob([new Uint8Array(await file.arrayBuffer())], {type: file.type})

export const createFileFormData = async (file: File) => {
  const formData = new FormData()
  const blob = await fileToBlob(file)
  formData.append('file', blob)
  return formData
}